import { Row, Col, Accordion } from 'react-bootstrap';

export default function LGPDAlepe() {
    return (
        <Row>
            <Col xs="12">
                <style>{`
                    .link-azul {
                        color: #000080; /* Navy */
                        font-weight: bold;
                    }
                    .encarregado-highlight {
                        background-color: #f0f8ff;
                        border: 2px solid #007bff;
                        padding: 1rem;
                        border-radius: 5px;
                    }
                `}</style>
                <p>
                    <small>
                        Você está em <a href="/dados-pessoais">Proteção de Dados Pessoais (LGPD)</a> / LGPD na Alepe
                    </small>
                </p>
            </Col>
            <Col xs="12">
                <Accordion defaultActiveKey="0" className="mb-5">
                    <Accordion.Item eventKey="0">
                        <Accordion.Header>A LGPD</Accordion.Header>
                        <Accordion.Body>
                            <p>
                                A{" "}
                                <a
                                    className="link-azul"
                                    href="https://www.planalto.gov.br/ccivil_03/_ato2015-2018/2018/lei/L13709compilado.htm"
                                >
                                    Lei Federal 13.709/2018
                                </a>
                                , mais conhecida como Lei Geral de Proteção de Dados Pessoais (LGPD), foi aprovada para que você tenha mais controle sobre suas próprias informações, reforçando direitos fundamentais como a liberdade e a privacidade. A LGPD é a principal instrumento legal do sistema de proteção de dados pessoais no Brasil, mas existem outras normas que abordam o tema, como o{" "}
                                <a
                                    className="link-azul"
                                    href="https://www.planalto.gov.br/ccivil_03/_ato2011-2014/2014/lei/l12965.htm"
                                >
                                    Marco Civil da Internet
                                </a>{" "}
                                e a{" "}
                                <a
                                    className="link-azul"
                                    href="https://www.planalto.gov.br/ccivil_03/_ato2011-2014/2011/lei/l12527.htm"
                                >
                                    Lei de Acesso à Informação (LAI)
                                </a>.
                            </p>
                            <p>
                                Desde 2022, a Constituição Federal também garante que “é assegurado, nos termos da lei, o direito à proteção dos dados pessoais, inclusive nos meios digitais” (art. 5º, LXXIX).
                            </p>

                            <p>
                                <strong>Fundamentos</strong>
                            </p>
                            <p>A LGPD possui como fundamentos:</p>
                            <ul style={{ listStyleType: 'disc', paddingLeft: '20px' }}>
                                <li>O respeito à privacidade</li>
                                <li>A autodeterminação informativa</li>
                                <li>A liberdade de expressão, de informação, de comunicação e de opinião</li>
                                <li>A inviolabilidade da intimidade, da honra e da imagem</li>
                                <li>O desenvolvimento econômico e tecnológico e a inovação</li>
                                <li>A livre iniciativa, a livre concorrência e a defesa do consumidor</li>
                                <li>
                                    Os direitos humanos, o livre desenvolvimento da personalidade, a dignidade e o exercício da
                                    cidadania pelas pessoas naturais
                                </li>
                            </ul>

                            <p>
                                <strong>Princípios</strong>
                            </p>
                            <p>
                                Além disso, a LGPD apresenta uma série de princípios para que seus dados pessoais sejam tratados com respeito e segurança:
                            </p>
                            <ul>
                                <li>
                                    <b>Finalidade:</b> realização do tratamento para propósitos legítimos, específicos, explícitos e informados ao titular, sem possibilidade de tratamento posterior de forma incompatível com essas finalidades;
                                </li>
                                <li>
                                    <b>Adequação:</b> compatibilidade do tratamento com as finalidades informadas ao titular, de acordo com o contexto do tratamento;
                                </li>
                                <li>
                                    <b>Necessidade:</b> limitação do tratamento ao mínimo necessário para a realização de suas finalidades, com abrangência dos dados pertinentes, proporcionais e não excessivos em relação às finalidades do tratamento de dados;
                                </li>
                                <li>
                                    <b>Livre acesso:</b> garantia, aos titulares, de consulta facilitada e gratuita sobre a forma e a duração do tratamento, bem como sobre a integralidade de seus dados pessoais;
                                </li>
                                <li>
                                    <b>Qualidade dos dados:</b> garantia, aos titulares, de exatidão, clareza, relevância e atualização dos dados, de acordo com a necessidade e para o cumprimento da finalidade de seu tratamento;
                                </li>
                                <li>
                                    <b>Transparência:</b> garantia, aos titulares, de informações claras, precisas e facilmente acessíveis sobre a realização do tratamento e os respectivos agentes de tratamento, observados os segredos comercial e industrial;
                                </li>
                                <li>
                                    <b>Segurança:</b> utilização de medidas técnicas e administrativas aptas a proteger os dados pessoais de acessos não autorizados e de situações acidentais ou ilícitas de destruição, perda, alteração, comunicação ou difusão;
                                </li>
                                <li>
                                    <b>Prevenção:</b> adoção de medidas para prevenir a ocorrência de danos em virtude do tratamento de dados pessoais;
                                </li>
                                <li>
                                    <b>Não discriminação:</b> impossibilidade de realização do tratamento para fins discriminatórios ilícitos ou abusivos;
                                </li>
                                <li>
                                    <b>Responsabilização e prestação de contas:</b> demonstração, pelo agente, da adoção de medidas eficazes e capazes de comprovar a observância e o cumprimento das normas de proteção de dados pessoais e, inclusive, da eficácia dessas medidas.
                                </li>
                            </ul>
                        </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey="1">
                        <Accordion.Header>LGPD na Alepe</Accordion.Header>
                        <Accordion.Body>
                            <p>
                                Para agilizar o processo de adequação à LGPD, a Alepe criou a Gerência de Proteção de Dados Pessoais, que faz parte da estrutura da Ouvidoria e foi instituída pela{" "}
                                <a
                                    className="link-azul"
                                    href="https://legis.alepe.pe.gov.br/texto.aspx?id=74617&tipo=TEXTOATUALIZADO"
                                >
                                    Lei 18.355/2023
                                </a>
                                . Este setor é responsável por promover a construção e a manutenção da cultura de privacidade e proteção de dados na Assembleia e atua como elo entre os titulares de dados, a Autoridade Nacional de Proteção de Dados (ANPD), a Ouvidoria e demais setores do Legislativo pernambucano.
                            </p>
                            <p>
                                Além disso, acessa os dados pessoais controlados pela Alepe; orienta servidores; acompanha a definição de medidas de segurança; presta esclarecimentos; adota providências nas manifestações dos titulares dos dados; e elabora relatórios sobre dados sensíveis.
                            </p>
                            <p>
                                A presidência da Alepe criou ainda um{" "}
                                <a className="link-azul" href="https://legis.alepe.pe.gov.br/texto.aspx?id=78393">
                                    Grupo de Trabalho de Adequação da Alepe à LGPD
                                </a>
                                . Como resultado, foi instituída a{" "}
                                <a className="link-azul" href="https://legis.alepe.pe.gov.br/texto.aspx?id=81407&tipo=">
                                    Política de Proteção de Dados Pessoais da Alepe
                                </a>
                                .
                            </p>
                            <p>
                                O texto prevê que o tratamento de dados pessoais pela Alepe será realizado exclusivamente para atender finalidades públicas e cumprir atribuições legais do serviço público. Além disso, detalha como cidadãos podem exercer seus direitos sobre as informações tratadas pela instituição, incluindo solicitações para corrigir ou excluir dados desnecessários.
                            </p>
                            <p>
                                Uma das inovações da política é a criação de um plano de capacitação para servidores e colaboradores.
                            </p>
                        </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey="2a">
                        <Accordion.Header>Legislação Geral</Accordion.Header>
                        <Accordion.Body>
                            <ul style={{ listStyleType: 'disc', paddingLeft: '20px' }}>
                                <li>
                                    <a className="link-azul" href="https://www.planalto.gov.br/ccivil_03/_ato2015-2018/2018/lei/L13709compilado.htm">
                                        Lei Geral de Proteção de Dados Pessoais
                                    </a>
                                </li>
                                <li>
                                    <a className="link-azul" href="https://www.planalto.gov.br/ccivil_03/_ato2011-2014/2014/lei/l12965.htm">
                                        Marco Civil da Internet
                                    </a>
                                </li>
                            </ul>
                        </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey="2b">
                        <Accordion.Header>Normativos internos</Accordion.Header>
                        <Accordion.Body>
                            <ul style={{ listStyleType: 'disc', paddingLeft: '20px' }}>
                                <li>
                                    <a className="link-azul" href="https://legis.alepe.pe.gov.br/texto.aspx?id=81407&tipo=">
                                        Ato da Mesa Diretora nº 2/2024 (Política de Proteção de Dados da Alepe)
                                    </a>
                                </li>
                                <li>
                                    <a className="link-azul" href="https://legis.alepe.pe.gov.br/texto.aspx?id=82776&tipo=">
                                        Ato da Mesa Diretora nº 1/2025 (Política de Segurança da Informação)
                                    </a>
                                </li>
                                <li>
                                    <a className="link-azul" href="https://legis.alepe.pe.gov.br/texto.aspx?id=82777&tipo=">
                                        Ato da Mesa Diretora nº 2/2025 (Programa de Capacitação em Proteção de Dados Pessoais da Alepe)
                                    </a>
                                </li>
                                <li>
                                    <a className="link-azul" href="https://legis.alepe.pe.gov.br/texto.aspx?id=4481&tipo=">
                                        LAI Alepe
                                    </a>
                                </li>
                                <li>
                                    <a className="link-azul" href="https://legis.alepe.pe.gov.br/texto.aspx?id=78393">
                                        Ato nº 1.501/2024 (Grupo de Trabalho de Adequação à LGPD)
                                    </a>
                                </li>
                            </ul>
                        </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey="2">
                        <Accordion.Header>Encarregado</Accordion.Header>
                        <Accordion.Body>
                            <p>
                                De acordo com a LGPD, encarregado é pessoa indicada pelo controlador e operador para atuar como canal de comunicação entre o controlador, os titulares dos dados e a Autoridade Nacional de Proteção de Dados (ANPD).
                            </p>
                            <div className="encarregado-highlight">
                                <p>
                                    Encarregado de dados pessoais da Alepe:<br />
                                    João Victor Rocha Leandro
                                    <br />
                                    Gerência de Proteção de Dados Pessoais | Ouvidoria
                                    <br />
                                    Contato:<br />
                                    encarregado.lgpd@alepe.pe.gov.br
                                    <br />
                                    (81) 3183-2003
                                </p>
                            </div>
                        </Accordion.Body>
                    </Accordion.Item>
                </Accordion>
            </Col>
        </Row>
    );
}
